import React from "react"
import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax
import { useRef, useEffect, useState } from 'react'

mapboxgl.accessToken = 'pk.eyJ1IjoiZXAyNzYyIiwiYSI6ImNremhleG5rdjBwaXkydnFyb2VqYWJxZG8ifQ.YLcMwi4JANjc0a-OEc8GqA';

const MyMap = () => {

  const mapContainer = useRef(null);
  const map = useRef(null);
  const [lng, setLng] = useState(-73.957710);
  const [lat, setLat] = useState(40.816582);
  const [zoom, setZoom] = useState(9);

  useEffect(() => {
    if (map.current) return; // initialize map only once
    map.current = new mapboxgl.Map({
      attributionControl: false,
      container: mapContainer.current,
      style: 'mapbox://styles/ep2762/ckzhgzixk000w14o3w67iyilq',
      center: [lng, lat],
      zoom: zoom,

    });
  }, []);

  return (
    <div>
      <div ref={mapContainer} className="map-container" />
    </div>
  );

}

export default MyMap

